export default __webpack_public_path__ + "static/jp-b838bfc58d143db0c901313136c64ff4.svg";